module.exports = __webpack_public_path__ + "static/commerce2x-seller-price-2b40b880e49b331a80699882fb36980f.jpg";